import { render, staticRenderFns } from "./SmTicketsTasksSummary.vue?vue&type=template&id=21276185&scoped=true&"
import script from "./SmTicketsTasksSummary.vue?vue&type=script&lang=ts&"
export * from "./SmTicketsTasksSummary.vue?vue&type=script&lang=ts&"
import style0 from "./SmTicketsTasksSummary.vue?vue&type=style&index=0&id=21276185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21276185",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
